<template>
  <div class="card shadow bg-secondary">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }} ทะเบียน {{ model.license_plate }}
          </h3>
        </div>
        <div class="col-md-1 col-6 text-right">
          <base-button
            type="primary"
            size="sm"
            @click="saveDocument"
            :disabled="isSaving"
            >บันทึก</base-button
          >
        </div>
      </div>
    </div>

    <div class="card-body pt-2 pt-md-4">
      <div class="row">
        <div class="col-12 col-md-4">
          <label for="id_card" class="form-control-label">บัตรประชาชน</label>
          <br />
          <input
            type="file"
            id="id_card"
            name="id_card"
            ref="id_card"
            accept="image/pdf, image/png , image/jpg , image/jpeg"
            @change="onIdCardChange"
          />
        </div>
        <!-- <div class="col-12 col-md-3">
          <label for="old_policy_number" class="form-control-label"
            >กรมธรรม์เดิม</label
          >
          <input
            type="file"
            id="old_policy_number"
            name="old_policy_number"
            ref="old_policy_number"
            accept="image/pdf, image/png , image/jpg , image/jpeg"
            @change="onOldPolicyNumberChange"
          />
        </div> -->
        <div class="col-12 col-md-4">
          <label for="vehicle_regis" class="form-control-label"
            >สำเนาทะเบียนรถ</label
          >
          <br />
          <input
            type="file"
            id="vehicle_regis"
            name="vehicle_regis"
            ref="vehicle_regis"
            accept="image/pdf, image/png , image/jpg , image/jpeg"
            @change="onVehicleRegisChange"
          />
        </div>
        <div class="col-12 col-md-4">
          <label for="other" class="form-control-label">เอกสารอื่นๆ</label>
          <br />
          <input
            type="file"
            id="other"
            name="other"
            ref="other"
            accept="image/pdf, image/png , image/jpg , image/jpeg"
            multiple
            @change="onOtherChange"
          />
        </div>
      </div>
      <!-- <div class="row mt-3">
        <div class="col-12 col-md-3">
          <h6 class="heading-small text-muted mb-4">บัตรประชาชน</h6>
        </div>
        <div class="col-12 col-md-3">
          <h6 class="heading-small text-muted mb-4">กรมธรรม์เดิม</h6>
        </div>
        <div class="col-12 col-md-3">
          <h6 class="heading-small text-muted mb-4">สำเนาทะเบียนรถ</h6>
        </div>
        <div class="col-12 col-md-3"></div>
      </div> -->

      <h6 class="heading-small text-muted mt-4">รูปอื่นๆ</h6>
      <div class="row">
        <div
          class="row"
          v-if="isLoaded && JSON.parse(model.assets).hasOwnProperty('other')"
        >
          <div
            v-for="item in JSON.parse(model.assets).other"
            :key="item"
            class="col-6 col-md-3 p-4"
          >
            <a :href="'/storage/' + item" target="_blank">
              <img
                :src="'/storage/' + item"
                style="height: 200px; object-fit: cover; overflow: hidden;"
                class="shadow-lg rounded"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import router from "../router";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "edit-document",
  mixins: [kickMixin],
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      isLoaded: false,
      isSaving: false,
      model: [],
      assets: {
        id_card: "",
        old_policy_number: "",
        vehicle_regis: "",
        other: "",
      },
    };
  },
  methods: {
    onIdCardChange() {
      this.assets.id_card = this.$refs.id_card.files[0];
      this.uploadIdCard();
    },
    onOldPolicyNumberChange() {
      this.assets.old_policy_number = this.$refs.old_policy_number.files[0];
      this.uploadOldPolicyNumber();
    },
    onVehicleRegisChange() {
      this.assets.vehicle_regis = this.$refs.vehicle_regis.files[0];
      this.uploadVehicleRegis();
    },
    onOtherChange() {
      let localApp = this;
      this.assets.other = localApp.$refs.other.files;

      // for (let i = 0; i < localApp.assets.other.length; i++) {
      //   localApp.files.push(localApp.assets.other[i]);
      // }

      this.uploadOther();
    },
    loadDocument: function() {
      var localApp = this;
      axios
        .get("/api/document/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.model = response.data.data;
          localApp.isLoaded = true;
        })
        .catch(function() {
          localApp.kick();
        });
    },
    uploadIdCard: function() {},
    uploadOldPolicyNumber: function() {},
    uploadVehicleRegis: function() {},
    uploadOther: function() {},
    saveDocument() {
      let localApp = this;
      localApp.isSaving = true;

      let formData = new FormData();
      formData.append("id", localApp.$route.params.id);
      formData.append("id_card", localApp.assets.id_card);
      formData.append("old_policy_number", localApp.assets.old_policy_number);
      formData.append("vehicle_regis", localApp.assets.vehicle_regis);
      formData.append("other", localApp.assets.other);

      for (let i = 0; i < localApp.assets.other.length; i++) {
        let file = localApp.assets.other[i];

        formData.append("other[" + i + "]", file);
      }

      axios
        .post("/api/document/upload", formData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type":
              "multipart/form-data;boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW",
          },
        })
        .then(function(response) {
          localApp.isSaving = false;
          if (response.status == 200) {
            router.push("/document");
          }
        })
        .catch(function(error) {
          localApp.isSaving = false;
          alert(error);
        });
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.loadDocument();
    }
  },
};
</script>
<style>
h4 {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}
</style>
